import { EcgLeads } from "../../../api/index.defs";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import GraphImg from "./GraphImg/GraphImg";
import styles from "./EcgGraph.module.css";
import useResponsive from "../../../hooks/useResponsive";
import graphPlaceholder from "../../../assets/ecg-graph/graph-compressed.png";
import rhythmPlaceholder from "../../../assets/ecg-graph/graph-compressed.png";

type EcgGraphProps = {
  graph: EcgLeads | undefined;
};

const EcgGraph = ({ graph, className }: PropsWithClassName<EcgGraphProps>) => {
  const { isMobile } = useResponsive();

  if (!graph) return null;
  return (
    <div className={`${className ?? ""}`}>
      <div className={`${isMobile ? styles.ecgGraphMobile : "mb-2"} d-flex `}>
        <GraphImg src={graph.l1} placeholder={graphPlaceholder} />
        <div className={`${isMobile ? styles.ecgGraphMobile : "mx-1"}`}></div>
        <GraphImg src={graph.avr} placeholder={graphPlaceholder} />
        <div className={`${isMobile ? styles.ecgGraphMobile : "mx-1"}`}></div>
        <GraphImg src={graph.v1} placeholder={graphPlaceholder} />
        <div className={`${isMobile ? styles.ecgGraphMobile : "mx-1"}`}></div>
        <GraphImg src={graph.v4} placeholder={graphPlaceholder} />
      </div>

      <div className={`${isMobile ? styles.ecgGraphMobile : "mb-2"} d-flex `}>
        <GraphImg src={graph.l2} placeholder={graphPlaceholder} />
        <div className={`${isMobile ? styles.ecgGraphMobile : "mx-1"}`}></div>
        <GraphImg src={graph.avl} placeholder={graphPlaceholder} />
        <div className={`${isMobile ? styles.ecgGraphMobile : "mx-1"}`}></div>
        <GraphImg src={graph.v2} placeholder={graphPlaceholder} />
        <div className={`${isMobile ? styles.ecgGraphMobile : "mx-1"}`}></div>
        <GraphImg src={graph.v5} placeholder={graphPlaceholder} />
      </div>

      <div className={`${isMobile ? styles.ecgGraphMobile : "mb-2"} d-flex `}>
        <GraphImg src={graph.l3} placeholder={graphPlaceholder} />
        <div className={`${isMobile ? styles.ecgGraphMobile : "mx-1"}`}></div>
        <GraphImg src={graph.avf} placeholder={graphPlaceholder} />
        <div className={`${isMobile ? styles.ecgGraphMobile : "mx-1"}`}></div>
        <GraphImg src={graph.v3} placeholder={graphPlaceholder} />
        <div className={`${isMobile ? styles.ecgGraphMobile : "mx-1"}`}></div>
        <GraphImg src={graph.v6} placeholder={graphPlaceholder} />
      </div>

      <GraphImg src={graph.rhythm} placeholder={rhythmPlaceholder} />
    </div>
  );
};

export default EcgGraph;
